import { Slider, Spin } from 'antd';
import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import { Button } from '..';
import { useImageCropper, Area } from '../hooks/useImageCropper';

type ImageCropperProps = {
  image: string;
  onCancel: () => void;
  onSave: (image: string) => void;
};

export const ImageCropper: React.FC<ImageCropperProps> = ({
  image,
  onCancel,
  onSave,
}: ImageCropperProps): JSX.Element => {
  const {
    getCroppedImg,
    croppedAreaPixels,
    crop,
    zoom,
    onCropChange,
    onZoomChange,
    onCropComplete,
  } = useImageCropper();

  const [loader, setLoader] = useState(false);

  const getCroppedImage = async () => {
    const croppedImage = await getCroppedImg(image, croppedAreaPixels as Area);
    onSave(croppedImage);
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
      onCancel();
    }, 2000);
  };

  return (
    <div className="image-cropper">
      <div className="image-cropper__cropper">
        <Cropper
          aspect={1}
          image={image}
          crop={crop}
          zoom={zoom}
          zoomSpeed={0.1}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          cropShape="round"
          onCropComplete={onCropComplete}
        />
      </div>
      <Slider
        defaultValue={1}
        value={zoom}
        tooltipVisible={false}
        min={1}
        max={3}
        step={0.05}
        onChange={onZoomChange}
      />
      <div className="image-cropper__btn-block">
        <Spin size="large" spinning={loader}>
          <Button
            className="image-cropper__btn-block__btn"
            variant="common"
            onClick={getCroppedImage}
          >
            Save
          </Button>
        </Spin>
      </div>

      <Button onClick={onCancel} className="image-cropper__btn" variant="text">
        Cancel
      </Button>
    </div>
  );
};
